/* @generated from adl module ferovinum.sourcecontracts.negativestockadjustment */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as ferovinum_app_db from './../app/db';

/**
 * The published `source__app_db.negative_stock_adjustment` contract.
 */
export interface NegativeStockAdjustmentSource {
  id: ferovinum_app_db.NegativeStockAdjustmentId;
  storageLocationId: ferovinum_app_db.StorageLocationId;
  referenceNumber: string;
  comment: (string|null);
  reimbursingCosts: boolean;
  additionalCostsStorage: (common.BigDecimal|null);
  additionalCostsLanding: (common.BigDecimal|null);
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeNegativeStockAdjustmentSource(
  input: {
    id: ferovinum_app_db.NegativeStockAdjustmentId,
    storageLocationId: ferovinum_app_db.StorageLocationId,
    referenceNumber: string,
    comment: (string|null),
    reimbursingCosts: boolean,
    additionalCostsStorage: (common.BigDecimal|null),
    additionalCostsLanding: (common.BigDecimal|null),
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): NegativeStockAdjustmentSource {
  return {
    id: input.id,
    storageLocationId: input.storageLocationId,
    referenceNumber: input.referenceNumber,
    comment: input.comment,
    reimbursingCosts: input.reimbursingCosts,
    additionalCostsStorage: input.additionalCostsStorage,
    additionalCostsLanding: input.additionalCostsLanding,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const NegativeStockAdjustmentSource_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.sourcecontracts.negativestockadjustment","decl":{"annotations":[{"value":{"modelName":"source__app_db.negative_stock_adjustment","grain":["id"],"tags":["revenue","source"]},"key":{"moduleName":"ferovinum.sourcecontracts.common","name":"SourceContract"}},{"value":"The published `source__app_db.negative_stock_adjustment` contract.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NegativeStockAdjustmentId"}},"parameters":[]}},{"annotations":[],"serializedName":"storageLocationId","default":{"kind":"nothing"},"name":"storageLocationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StorageLocationId"}},"parameters":[]}},{"annotations":[],"serializedName":"referenceNumber","default":{"kind":"nothing"},"name":"referenceNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"comment","default":{"kind":"nothing"},"name":"comment","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"reimbursingCosts","default":{"kind":"nothing"},"name":"reimbursingCosts","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"additionalCostsStorage","default":{"kind":"nothing"},"name":"additionalCostsStorage","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}]}},{"annotations":[],"serializedName":"additionalCostsLanding","default":{"kind":"nothing"},"name":"additionalCostsLanding","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"NegativeStockAdjustmentSource","version":{"kind":"nothing"}}};

export const snNegativeStockAdjustmentSource: ADL.ScopedName = {moduleName:"ferovinum.sourcecontracts.negativestockadjustment", name:"NegativeStockAdjustmentSource"};

export function texprNegativeStockAdjustmentSource(): ADL.ATypeExpr<NegativeStockAdjustmentSource> {
  return {value : {typeRef : {kind: "reference", value : snNegativeStockAdjustmentSource}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.sourcecontracts.negativestockadjustment.NegativeStockAdjustmentSource" : NegativeStockAdjustmentSource_AST
};
